import { api } from '@/shared/api'
import { DocumentRecord } from '@synapex/prisma/client'
import { GoogleUserInfoDto } from '@synapex/shared'
import { AccountLikeDescriptor } from '@synapex/shared2/entities'
import {
    AccountLikeDescriptorDto,
    ActUnion,
    ContractUnion,
    DeleteContractInputDto,
    GenerateActInputDto,
    GenerateContractInputDto,
    GetActsInputDto,
    GetContractsInputDto,
    GetInvoicesInputDto,
    GoogleLoginInputDto,
    UpdateActNumberInputDto,
    UpdateContractInputDto,
    UpdateContractNumberInputDto,
    UploadFinalActInputDto,
    UploadFinalContractInputDto,
    UploadInvoiceInputDto,
} from '@synapex/shared2/gateway-rest-api'
import { pickDto } from '../utils'

export const apiGoogleLogin = (params: GoogleLoginInputDto) => {
    return api.get<{ url: string; siteId: number }>(
        `/drive-google/google/login`,
        {
            params: pickDto(GoogleLoginInputDto, params),
        }
    )
}

export const apiGoogleLogout = (params: AccountLikeDescriptor) =>
    api.get<{ url: string; siteId: number }>(`/drive-google/google/logout`, {
        params: pickDto(AccountLikeDescriptorDto, params),
    })

export const apiGenerateAct = (body: GenerateActInputDto) =>
    api.post('/drive-google/generate-act', pickDto(GenerateActInputDto, body))

export const apiGetActs = (params: GetActsInputDto) =>
    api.get<ActUnion[]>(`/drive-google/acts`, {
        params: pickDto(GetActsInputDto, params),
    })

export const apiDeleteAct = (documentRecordId: number) =>
    api.delete<{ message: string }>(
        `/drive-google/delete-act/${documentRecordId}`
    )

export const apiUploadActFile = ({
    file,
    ...data
}: UploadFinalActInputDto & { file: File }) => {
    return api.post(
        '/drive-google/upload-act',
        {
            ...pickDto(UploadFinalActInputDto, data),
            file,
        },
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    )
}

export const apiGenerateContract = (body: GenerateContractInputDto) =>
    api.post(
        '/drive-google/generate-contract',
        pickDto(GenerateContractInputDto, body)
    )

export const apiUpdateContract = (body: UpdateContractInputDto) =>
    api.post(
        '/drive-google/update-contract',
        pickDto(UpdateContractInputDto, body)
    )

export const apiUpdateContractNumber = (body: UpdateContractNumberInputDto) =>
    api.post(
        '/drive-google/update-contract-number',
        pickDto(UpdateContractNumberInputDto, body)
    )

export const apiUpdateActNumber = (body: UpdateActNumberInputDto) =>
    api.post(
        '/drive-google/update-act-number',
        pickDto(UpdateActNumberInputDto, body)
    )

export const apiDeleteContract = (body: DeleteContractInputDto) =>
    api.post(
        '/drive-google/delete-contract',
        pickDto(DeleteContractInputDto, body)
    )

export const apiGetGoogleUserInfo = (params: AccountLikeDescriptor) =>
    api.get<GoogleUserInfoDto>(`/drive-google/info`, {
        params: pickDto(AccountLikeDescriptorDto, params),
    })

export const apiGetContracts = (params: GetContractsInputDto) =>
    api.get<ContractUnion[]>(`/drive-google/contracts`, {
        params: pickDto(GetContractsInputDto, params),
    })

export const apiGetInvoices = (params: GetInvoicesInputDto) =>
    api.get<DocumentRecord[]>(`/drive-google/invoices`, {
        params: pickDto(GetInvoicesInputDto, params),
    })

export const apiUploadContractFile = ({
    file,
    ...data
}: UploadFinalContractInputDto & { file: File }) => {
    return api.post(
        '/drive-google/upload-final-contract',
        {
            ...pickDto(UploadFinalContractInputDto, data),
            file,
        },
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    )
}

export const apiUploadInvoiceFile = ({
    file,
    ...data
}: UploadInvoiceInputDto & { file: File }) => {
    return api.post(
        '/drive-google/upload-invoice',

        {
            ...pickDto(UploadInvoiceInputDto, data),
            file,
        },
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    )
}

export const apiSendToTelegramGoogleDriveFile = (fileId: number) =>
    api.post(`/drive-google/send-to-telegram/${fileId}`, undefined)
